<template>
  <tr>
    <td>{{ getFullName(patient) }}</td>
    <td>{{ birthDate }}</td>
    <td>{{ patient.phone }}</td>
    <td>{{ patient.address }}</td>
    <td>
      <template v-if="hasActiveCourse">
        <router-link
          v-if="hasRightsToActiveCourse"
          :to="{ name: 'course-edit', params: { id: activeCourse.id } }"
          class="text-nowrap text-small text-success"
          >{{ $t('entity.course') }} {{ activeCourse.id }}</router-link
        >
        <span v-else class="text-small text-nowrap"
          >{{ $t('entity.course') }} {{ activeCourse.id }}, {{ activeCourseDoctorName }}</span
        >
      </template>
      <router-link
        v-else-if="this.isManageAnyCourse"
        :to="{ name: 'course-add', query: { patient: patient.id } }"
        class="text-nowrap text-small"
        >{{ $t('button.createCourse') }}</router-link
      >
      <span v-else class="text-danger small">{{ $t('src/components/table-rows/patienttablerow.6754') }}</span>
    </td>
    <td>
      <button v-if="!isNeuroAdmin && !isReadonly" class="btn btn-outline-primary" @click="editPatient">
        {{ $t('button.edit') }}
      </button>
    </td>
  </tr>
</template>

<script>
import { fullName } from '@/mixins/full-name.js'
import { userRights } from '@/mixins/user-rights'
import { DATE_FORMAT, status } from '@/main.config'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'PatientTableRow',
  mixins: [fullName, userRights, systemUnavailable],
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  computed: {
    authUserId() {
      return this.$store.getters.AUTH_USER.id
    },
    birthDate() {
      return this.moment(this.patient.birth_date, DATE_FORMAT.server).format(
        DATE_FORMAT[`${this.$store.getters.LOCALE}`]
      )
    },
    activeCourse() {
      return this.patient.courses.find(course => course.status === status.active)
    },
    activeCourseDoctorName() {
      if (!this.activeCourse) {
        return
      }
      return this.getSurnameWithInitials({
        surname: this.activeCourse.doctor_surname,
        name: this.activeCourse.doctor_name
      })
    },
    hasRightsToActiveCourse() {
      if (!this.activeCourse || this.isReadonly) {
        return false
      }
      if (this.isOnlyDoctor) {
        return +this.activeCourse.doctor_id === +this.authUserId
      }
      return true
    },
    hasActiveCourse() {
      return Boolean(this.activeCourse)
    }
  },
  methods: {
    editPatient() {
      if (Number(localStorage.getItem('activeHospital'))) {
        this.$router.push({ name: 'patient-edit', params: { id: this.patient.id } })
      } else {
        this.$emit('system:unavailable')
      }
    }
  }
}
</script>
